module.exports = __webpack_public_path__ + "b551b554a67e86a840bc80cbb8066c30.svg";